const DX_FRAGMENT = `
  fragment dxFragment on ExamQuizDx {
    words {
      id
      question
      answer
      answerIndex
      options
      audioUrl
    }
  }
`;

const TX_FRAGMENT = `
  fragment txFragment on ExamQuizTx {
    words {
      id
      text
      explain
      audioUrl
    }
  }
`;

// eslint-disable-next-line
export const EXAMDATA = `
  query(
    $scene: String!,
    $courseId: Int,
    $modeId: Int,
    $unitId: Int,
    $types: String,
    $quantity: Int
  ) {
    examData(
      scene: $scene,
      courseId: $courseId,
      modeId: $modeId,
      unitId: $unitId,
      types: $types,
      quantity: $quantity
    ) {
      summary {
        total
        title
      }
      quizzes {
        id
        name
        code
        mode
        ...dxFragment
        ...txFragment
      }
    }
  }
  ${DX_FRAGMENT}
  ${TX_FRAGMENT}
`;

export const SUBMITEXAMRESULT = `
  mutation(
    $scene: String!,
    $courseId: Int,
    $modeId: Int,
    $unitId: Int,
    $words: String,
    $seconds: Int,
    $record:String,
  ) {
    submitExamResult(
      scene: $scene,
      courseId: $courseId,
      modeId: $modeId,
      unitId: $unitId,
      record: $record,
      words: $words,
      seconds: $seconds,
    ) {
      force
      score
    }
  }
`;
